(()=>{
const init=root=>root.querySelectorAll('[data-culture]').forEach(group=>{
  if(group.dataset.ready)return;
  const buttons=Array.from(group.querySelectorAll('[data-culture-choice]'));
  const panels=Array.from(group.querySelectorAll('[data-culture-panel]'));
  const controls=group.querySelector('.se-culture-choices');
  if(!buttons.length||buttons.length!==panels.length||!controls)return;
  const choose=(index,animate=false)=>{
    buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
    panels.forEach((panel,i)=>{
      panel.hidden=i!==index;
      panel.classList.remove('se-culture-enter');
      if(i===index&&animate&&!matchMedia('(prefers-reduced-motion: reduce)').matches&&!group.closest('.se-paused')){
        void panel.offsetWidth;
        panel.classList.add('se-culture-enter');
      }
    });
  };
  buttons.forEach((button,index)=>button.addEventListener('click',()=>choose(index,true)));
  choose(0);
  group.dataset.ready='true';
  controls.hidden=false;
});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
document.addEventListener('shopify:section:load',event=>init(event.target));
})();
